export const MAXIMUM_COURSE_POINTS = 10000;

export const WEIGHT_OF_ONE_PERCENT = MAXIMUM_COURSE_POINTS / 100;
